import {RootState} from "../../store/rootReducer";

export const reviewStoreSelector = (state: RootState) => {
    return state.review;
}